module.exports = __webpack_public_path__ + "static/carlsbad-11-e4dced63fcce60bbead7e4659a8c7955.jpeg";